import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import moment from 'moment'

const PickupAndDelivery = ({title}) => {
    const tracking = useSelector<RootState>(({pages}) => pages.tracking) as any

    const isActual = title.includes('Actual')
    const isPickup = title.includes('Pickup')

    // Scheduled rows ("Pickup On" / "Delivery By") show the estimated date and its
    // From/To time window. The "Actual Pickup" / "Actual Delivery" rows show the
    // actual date + time coming from the PICKED UP / DELIVERED status (stored as a
    // datetime in actualPickupDate / actualDeliveryDate), matching the legacy which
    // displays a single date + Time for the actuals.
    const actualDate = isPickup ? tracking?.rowData?.actualPickupDate : tracking?.rowData?.actualDeliveryDate
    const scheduled = isPickup ? tracking?.pickupDate : tracking?.deliveryDate

    const dateValue = isActual ? actualDate : scheduled?.date
    // actualPickupDate / actualDeliveryDate come from the PICKED UP / DELIVERED
    // status, which carries a time. Show it only when the value actually includes
    // one, so a date-only value never renders a misleading "00:00".
    const actualTime = typeof actualDate === 'string' && /\d{1,2}:\d{2}/.test(actualDate)
        ? moment(actualDate).format('HH:mm')
        : ''

    const fromTime = scheduled?.from ? moment(scheduled?.from, "HH:mm:ss").format('HH:mm') : '-'
    const toTime = scheduled?.to ? moment(scheduled?.to, "HH:mm:ss").format('HH:mm') : '-'

    // Fixed-width columns keep the label / date / time aligned across all four rows
    // (labels vary in length: "Pickup On", "Delivery By", "Act. Pickup"...).
    return (
        <>
            <div className="col-6 col-sm-5 d-flex align-items-center mt-2 mt-sm-0">
                <label className='col-form-label p-0' style={{width: 112, whiteSpace: 'nowrap'}}>{title}</label>
                <div style={{width: 64}}>
                    {dateValue ? moment(dateValue).format('MM/DD/YY') : '-'}
                </div>
            </div>
            <div className="col-6 col-sm-7 d-flex align-items-center mt-2 mt-sm-0">
                {isActual
                ? <>
                    <label className='col-form-label p-0' style={{width: 44}}>Time</label>
                    <div style={{width: 48}}>{actualTime || '-'}</div>
                </>
                : <>
                    <label className='col-form-label p-0' style={{width: 44}}>From</label>
                    <div style={{width: 48}}>{fromTime}</div>
                    <label className='col-form-label p-0 me-2'>To</label>
                    <div style={{width: 48}}>{toTime}</div>
                </>}
            </div>
        </>
    )
}

export default PickupAndDelivery